// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1179":"d8d5270fae5ff92b","4439":"1ae9a8ef12c0cfda","5801":"f3f9e89967577fc1","7744":"1e5f4fa3e842091f","7746":"7ea1d912ab1d721e","9591":"1817a7751d90e4d0","9860":"35fb00edf7791b7f"}[chunkId] + ".1781179037442.js";
};